// extracted by mini-css-extract-plugin
export default {"wrapper":"CollectionsPage_wrapper__LyR2S"};